/* packages/volto-castle-theme/src/components/HPCustomerSupport/HPCustomerSupport.tsx */
import React from 'react';

import supportImg from '../../../static/img/support.png';

const HPCustomerSupport: React.FC = () => {
  return (
    <section className="hp-support hp-fullbleed" aria-label="Customer support">
      <div className="hp-support__container">
        <div className="hp-support__grid">
          <div className="hp-support__image" aria-hidden="true">
            <img className="hp-support__img" src={supportImg} alt="" />
          </div>

          <div className="hp-support__content">
            <h2 className="hp-support__title">24/7 CUSTOMER SUPPORT</h2>

            <p className="hp-support__text">
              Built using the latest web
              technologies like html5, css3, and jQuery, rest assured Sedna will look smashing on
              every device under the sun.
            </p>

            <a className="hp-support__cta" href="contact" title='Contact Us' aria-label="Need our help? Let's chat">
              <span className="hp-support__ctaText">NEED OUR HELP ? LET&apos;S CHAT</span>
              <span className="hp-support__ctaArrow" aria-hidden="true">
                →
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HPCustomerSupport;
